import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export interface ResourcePollingData {
  versionId: string | undefined;
  isActive: boolean;
  lastCalled: string;
}

interface ResourcePollingState {
  [key: string]: ResourcePollingData;
}

const initialState: ResourcePollingState = {};

const reducers = {
  startResourcePolling: (
    state: ResourcePollingState,
    action: PayloadAction<{ key: string; versionId?: string }>,
  ) => {
    const { key, versionId } = action.payload;
    state[key] = {
      versionId,
      isActive: true,
      lastCalled: new Date().toISOString(),
    };
  },
  stopResourcePolling: (state: ResourcePollingState, action: PayloadAction<string>) => {
    const key = action.payload;
    state[key] = {
      ...state[key],
      isActive: false,
    };
  },
};

export const pollingSlice = createSlice({
  name: "polling",
  initialState,
  reducers,
});

export const { startResourcePolling, stopResourcePolling } = pollingSlice.actions;

export default pollingSlice.reducer;

const selectPollingState = (state: RootState) => state.resourcePolling;

export const selectPollingDataByKey = createSelector(
  [selectPollingState, (_: RootState, key: string) => key],
  (pollingState, key): ResourcePollingData =>
    pollingState[key] ?? { isActive: false, versionId: undefined },
);
